<template>
    <vx-modal :title="$t('MODALS.originSelectTrigger.title')">
        <template v-slot:body>           
            <div class="filtros flex justify-between items-center">
                <div class="flex w-1/2">
                    <vs-select v-model="questionsByPage[indexQuestion].properties.originKey" autocomplete class="selectExample w-full" @change="getColumns()">
                        <vs-select-item :key="index" :value="item.key" :text="item.description" v-for="(item,index) in listOrigins" />
                    </vs-select>
                    <!-- <vs-button class="ml-2" color="success" type="border" icon-pack="feather" icon="icon-search"></vs-button> -->
                </div>
                <span>{{$t('MODALS.originSelectTrigger.total')}} {{total_register}}</span>
                <div class="filtro-2">
                    <i class="vs-icon notranslate icon-scale vs-button--icon  feather icon-grid null" style="font-size: 20px"></i>
                </div>
            </div>
            <div class="data w-full flex">              
                <div class="fields pl-2 flex justify-between flex-col">
                    <ul class="mt-2 w-full">
                        <li>                            
                          <vs-checkbox v-model="isChecked" :vs-value="true" @change="selectAll(isChecked)"><b>{{$t('MODALS.originSelectTrigger.all')}}</b></vs-checkbox>
                        </li>
                    </ul>
                    <ul class="mt-2 w-full overflow-auto" style="height: 85%">
                        <li v-for="(campo, index) in columns" style="font-size: 13px" :key="index">
                          <vs-checkbox v-model="SelectedHeaders" :vs-value="campo" ><span class="truncate inline-block" style="width: 120px;">{{campo}}</span></vs-checkbox>         
                        </li>                        
                    </ul>
                    <div class="flex items-center justify-center py-3">
                        <vs-button color="success" type="border" :disabled="SelectedHeaders.length === 0" @click="PreviweData()">{{$t('MODALS.originSelectTrigger.Preview')}}</vs-button>                    
                    </div>
                </div>
                <div class="view-table">
                    <div class="content-table">
                        <table>
                            <thead>
                                <tr>
                                    <th style="min-width: 10px;padding: 6px 6px" v-if="SelectedHeaders.length > 0">Item</th>
                                    <th v-for="(campo, index) in SelectedHeaders" :key="index">{{campo}}</th>                                     
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in previewData" :key="index">
                                    <td style="min-width: 12px;padding: 6px 6px; text-align: center">{{index + 1}}</td>                                     
                                    <td v-for="(header, i) in SelectedHeaders" :key="i">{{item[header]}}</td>                                        
                                </tr>
                            </tbody>                            
                        </table>
                    </div>                   
                </div>                 
            </div>
        </template>
    </vx-modal>
</template>
<script type="text/javascript">
import { mapState, mapMutations } from 'vuex';

import Api from '@/helpers/api.js';
import InputNumber from '../Number.vue';
import { getColumnsOrigin, setColumnsOrigin } from '../../indexDB/logic.js'
export default {
	components: { InputNumber },
    data() {
        return {                     
            originKey: '',
            cantRegister: 20,
            columns: [],
            SelectedHeaders: [],
            previewData: [],
            isChecked: false,
            headers: [],
            SelectedHeaders: []
        }
    },
    async mounted() {
        const originKey = this.questionsByPage[this.indexQuestion].properties.originKey;
        const _columns = this.listOrigins.filter(origin => origin.key === originKey);
        if(_columns.length > 0) {           
            this.columns = _columns[0].columns;
        }      

        if(this.questionsByPage[this.indexQuestion].query.action) {
            if(this.questionsByPage[this.indexQuestion].query.action !== 'trigger') { 
                const columns = await getColumnsOrigin();
                const nameQuestion = this.questionsByPage[this.indexQuestion].name;                    
                if(columns[nameQuestion]) {                        
                    this.SelectedHeaders = columns[nameQuestion];                   
                    if(this.SelectedHeaders.length > 0) this.PreviweData();
                    
                }
               
            }
        }
    },
    watch: {
    	activePopup: function(value) {
    		if(!value) this.clearData();
    	},
        SelectedHeaders: async function(value) {
            if(value.length > 0) {                          
                if(this.questionsByPage[this.indexQuestion].query) {
                    if(this.questionsByPage[this.indexQuestion].query.action !== 'trigger') {                       
                        const _columns = value.map( item => item);                    
                        const columns = await getColumnsOrigin();                        
                        const nameQuestion = this.questionsByPage[this.indexQuestion].name;
                        let ObjectColumns = { ...columns};
                        ObjectColumns[nameQuestion] = _columns;
                        setColumnsOrigin(ObjectColumns);
                    }

                }
                               
            }           
        }
    },
    methods: {
    	...mapMutations('resource', ['UPDATE_STATE']),
    	getColumns() { 
            const inputType = this.questionsByPage[this.indexQuestion].inputType;
            // console.log('UUUUUUUUUUUUUUUUUUU ',)
            if(inputType === 'database' || inputType === 'standar') {
                this.questionsByPage[this.indexQuestion].properties.searchField = '';
            }else if(this.questionsByPage[this.indexQuestion].properties.originKey === 'N/A') {
                this.questionsByPage[this.indexQuestion].properties.searchField = '';
            }
                     
            const originKey = this.questionsByPage[this.indexQuestion].properties.originKey;           
    		if(originKey.trim().length > 0) {
    			const columns = this.listOrigins.filter(origin => origin.key === originKey);
    			this.columns = columns[0].columns;
                this.SelectedHeaders = [];
                this.previewData = [];
                this.isChecked = false;
                const nameQuestion = this.questionsByPage[this.indexQuestion].name;                    
                // setColumnsOrigin([], nameQuestion);
    		}    		
    	},
    	async PreviweData() {
    		try {    			
    			const result = await this.apiColumns();    			
    			this.previewData =  result.data;
    		}catch(error) {
    			console.log(error)
    		}
    	},
    	async apiColumns() {
    		try { 
                const originKey = this.questionsByPage[this.indexQuestion].properties.originKey;             
    			const data = {
    				originID: originKey,
    				columns: this.SelectedHeaders,
    				// limit: 20
    				limit: 0

    			}
    			const result = await Api.post('/origins/columns',data);	
    			return result;									
    		} catch(e) {
    			// statements
    			console.log(e);
    		} finally {
    			// statements
    		}
    	},
    	clearData() {
    		this.SelectedColumn = '';           
    		this.originKey = '';
    		this.cantRegister = 20;
    		this.columns = [];
    		this.dataColumns = []
    	},      
        selectAll(isChecked) {
            if(isChecked) this.SelectedHeaders = this.columns;
            else {
                this.SelectedHeaders = [];
                this.previewData = [];
            }
            
        },
    },
    computed: {
    	...mapState('resource', ['listOrigins', 'indexQuestion', 'questionsByPage', 'activePopup']),    	
    	question() {
    		return this.questionsByPage[this.indexQuestion];
    	},  
    	total_register() {	
        	const originKey = this.questionsByPage[this.indexQuestion].properties.originKey;		
    		if(originKey.trim().length > 0) {
                if(originKey !== 'N/A') {
                    const totalRecords = this.listOrigins.filter(origin => origin.key === originKey)[0].totalRecords;              
                    this.questionsByPage[this.indexQuestion].properties.limit = totalRecords === 0?1:totalRecords;
                    return totalRecords;
                }
                this.questionsByPage[this.indexQuestion].properties.limit = 1;
                return 0;
                
    		}else {
    			return  0;
    		}			
    	},
    }
}
</script>

<style type="text/css" scoped>
    .filtros {
        border-bottom: 1px solid rgba(110,110,110, .2);
        padding: 20px;
    }
    .data { 
        height: calc(502px - 79px);     
        /*background: red;*/
    }

    .fields {
        /*background: blue;*/
        width: 25%;
        height: 100%;
        border-right: 1px solid rgba(110,110,110, .2);
    }



    .view-table{
        box-sizing: box-border;
        width: 75%;
        height: 100%;
        overflow: auto;
    }



    .view-table .content-table{
        height: 100%;
        overflow: auto;
    }

    .view-table table {
        border-collapse: collapse;
        border: 1px solid rgb(110,110,110, .2);
    }

    .view-table table thead tr th,
    .view-table table tbody tr td {
        border: 1px solid rgb(110,110,110, .2);
        min-width: 150px;
        height: 30px;
    }

    .view-table table tbody tr td {
        padding: 6px 10px;
        padding-top: 5px;
        padding-bottom: 3px;
    }
</style>
